/**
 * Brand Tabs - Handles brand tab selection and highlighting
 */
const defaultBrand = 'stark';

function getBrandFromStorage() {
    let storedData = localStorage.getItem('selectedBrand');
    if (!storedData) {
        saveBrandToStorage(defaultBrand);
        storedData = localStorage.getItem('selectedBrand');
    };
    
    try {
        const data = JSON.parse(storedData);
        
        // Check if the stored data has expired
        if (data.expiry && new Date().getTime() > data.expiry) {
            localStorage.removeItem('selectedBrand');
            return null;
        }
        
        return data.value;
    } catch (e) {
        // Handle legacy format (just in case)
        return storedData;
    }
}

function saveBrandToStorage(brandName) {
    // Set expiration to 30 days from now
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 30);
    
    const data = {
        value: brandName.toLowerCase().replace(/ /g, '_'),
        expiry: expiryDate.getTime()
    };
    
    localStorage.setItem('selectedBrand', JSON.stringify(data));
}

function highlightBrand(brandName, tabs) {
    tabs.forEach(tab => tab.classList.remove('selected-brand'));

    const selectedTab = Array.from(tabs).find(tab => {
        const getTabBrand = tab.getAttribute('data-brand') || tab.textContent.trim();
        const tabbedBrandParsed = getTabBrand.toLowerCase().replace(/ /g, '_');
        return tabbedBrandParsed === brandName;
    });

    if (selectedTab) {
        selectedTab.classList.add('selected-brand');
        
        // Add data-brand-selected attribute to body tag
        document.body.setAttribute('data-brand-selected', brandName);
    }
}

function enableBrandMenu(brandName) {
    const brandLowerCase = brandName.toLowerCase().replace(/ /g, '_');
    const brandUpperCase = brandName.toUpperCase();
    const brandUpperCaseRemoveUnderscore = brandUpperCase.replace(/_/g, ' ');
    const brandMenus = document.querySelectorAll('[id^="brand-header__"]');
    const starkMainMenu = document.getElementById('stark_main_menu');
    const mobileMenuButton = document.getElementById('mobile-menu-toggle');
    const brandMainLogoImage = document.getElementById(`brand-main-logo-image__${brandLowerCase}`);
    const brandMainLogoImageAll = document.querySelectorAll(`[id^="brand-main-logo-image__"]`);
    const brandContentGroups = document.querySelectorAll(`[id^="brand-group-"]`);
    const brandContent = document.getElementById(`brand-group-${brandLowerCase}`);
    const mainHeaderLogo = document.querySelector('.header__logo');
    const mainHeaderLogoSpan = mainHeaderLogo.querySelector('.header__logo-link span');
    const mainHeaderLogoImage = mainHeaderLogo.querySelector('.header__logo-image');
    const templateType = document.body.getAttribute('data-template-type');
    const allLinks = document.querySelectorAll('a');
    const updateAllLinksWithBrand = (selectedBrand) => {
        allLinks.forEach(link => {
            const linkUrl = new URL(link.href);
            linkUrl.searchParams.set('selectedbrand', `${selectedBrand}_brand`);
            link.href = linkUrl.toString();
        });
    };
    const hideOtherBrandContentGroups = (selectedBrand) => {
        const otherBrandContentGroups = Array.from(brandContentGroups).filter(content => 
            content.id !== `brand-group-${selectedBrand}`);
        otherBrandContentGroups.forEach(group => group.style.display = 'none');
    };
    
    // Common operations for all brand selections
    mainHeaderLogoSpan.textContent = brandUpperCaseRemoveUnderscore;

    if(templateType === 'index'){
        brandContent.style.display = 'block';
    }
    // Hide all other brand logos
    const otherBrandLogos = Array.from(brandMainLogoImageAll).filter(image => 
        image.id !== `brand-main-logo-image__${brandLowerCase}`);
    otherBrandLogos.forEach(image => image.style.display = 'none');
    
    if(brandLowerCase === defaultBrand) {
        starkMainMenu.style.display = 'block';
        mainHeaderLogoImage.style.display = 'block';
        mobileMenuButton.setAttribute('aria-controls', 'mobile-menu-drawer_stark');
        
        brandMenus.forEach(menu => menu.style.display = 'none');
        hideOtherBrandContentGroups(brandLowerCase);
    } else {
        const starkMainMenuParent = starkMainMenu.parentNode;
        const mainHeaderLogoImageParent = mainHeaderLogoImage.parentNode;
        const allCollectionLinks = document.querySelectorAll('a[href*="/collections"]');
        
        starkMainMenu.style.display = 'none';
        mainHeaderLogoImage.style.display = 'none';
        
        brandMenus.forEach(menu => {
            const menuBrand = menu.id.replace('brand-header__', '');
            const brandTabsContainer = document.getElementById('brand-tabs-container');
            const updateFilterOnCollectionPage = brandTabsContainer?.dataset?.updateFilterOnCollectionPage === 'true';

            if(brandLowerCase === menuBrand) {
                menu.style.display = 'block';
                brandMainLogoImage.style.display = 'block';
                mobileMenuButton.setAttribute('aria-controls', `mobile-menu-drawer_${menuBrand}`);
                
                // Insert menu DOM right after starkMainMenu DOM
                if (starkMainMenuParent) {
                    starkMainMenuParent.insertBefore(menu, starkMainMenu.nextSibling);
                }
                
                // Insert logo DOM
                if (mainHeaderLogoImageParent) {
                    mainHeaderLogoImageParent.insertBefore(brandMainLogoImage, mainHeaderLogoImage.nextSibling);
                }
                
                // Modify all collection links to include the brand vendor filter
                if(updateFilterOnCollectionPage) {
                    allCollectionLinks.forEach(link => {
                        try {
                            const linkUrl = new URL(link.href);
                            if (linkUrl.pathname.includes('/collections')) {
                                linkUrl.searchParams.set('filter.p.vendor', brandUpperCaseRemoveUnderscore);
                                link.href = linkUrl.toString();
                            }
                        } catch (e) {
                            if (link.getAttribute('href').includes('/collections')) {
                                const href = link.getAttribute('href');
                                const hasParams = href.includes('?');
                                const separator = hasParams ? '&' : '?';
                                link.setAttribute('href', `${href}${separator}filter.p.vendor=${brandUpperCaseRemoveUnderscore}`);
                            }
                        }
                    });
                }
            } else {
                menu.style.display = 'none';
            }
        });

        if(templateType === 'index'){
            hideOtherBrandContentGroups(brandLowerCase);
        }
    }

    updateAllLinksWithBrand(brandLowerCase);

    // Add selectedbrand URL parameter
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('selectedbrand', `${brandLowerCase}_brand`);
    
    // Update URL without page reload
    window.history.replaceState({}, '', currentUrl.toString());
}

function enableBrandCollection(brandName, updateFilterOnCollectionPage) {
    const brandLowerCase = brandName.toLowerCase().replace(/ /g, '_');
    const templateType = document.body.getAttribute('data-template-type');

    if(updateFilterOnCollectionPage) {
        if(templateType === 'collection') {
            if(brandLowerCase === defaultBrand) {
                // Remove vendor filter
                const currentUrl = window.location.href;
                const url = new URL(currentUrl);
                
                if (url.searchParams.has('filter.p.vendor')) {
                    url.searchParams.delete('filter.p.vendor');
                    
                    window.history.replaceState({}, '', url.toString());
                    window.location.reload();
                }
            } else {
                const brandUpperCase = brandName.toUpperCase();
                const brandUpperCaseRemoveUnderscore = brandUpperCase.replace(/_/g, ' ');
                // Add vendor filter
                const currentUrl = window.location.href;
                const url = new URL(currentUrl);

                url.searchParams.set('filter.p.vendor', brandUpperCaseRemoveUnderscore);
                
                window.history.replaceState({}, '', url.toString());
                window.location.reload();
            }
        }
    } else {
        if(templateType !== 'index'){
            // Redirect to homepage when filter is disabled and not on homepage
            window.location.href = '/';
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const brandTabs = document.querySelectorAll('.brand-tab');
    const brandTabsContainer = document.getElementById('brand-tabs-container');
    const updateFilterOnCollectionPage = brandTabsContainer?.dataset?.updateFilterOnCollectionPage === 'true';

    if (brandTabs.length === 0) {
        saveBrandToStorage(defaultBrand);
    };

    const brandUrlParam = new URLSearchParams(window.location.search).get('selectedbrand');
    if (brandUrlParam) {
        const brandName = brandUrlParam.replace('_brand', '');
        saveBrandToStorage(brandName);
    }

    // Load stored brand selection
    const storedBrand = getBrandFromStorage();
    if (storedBrand) {
        highlightBrand(storedBrand, brandTabs);
        enableBrandMenu(storedBrand);
    }

    // Add click listeners to tabs
    brandTabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const brand = tab.getAttribute('data-brand') || tab.textContent.trim();
            const brandName = brand.toLowerCase().replace(/ /g, '_');

            // Store selection and update UI
            saveBrandToStorage(brandName);
            highlightBrand(brandName, brandTabs);
            enableBrandMenu(brandName);
            enableBrandCollection(brandName, updateFilterOnCollectionPage);
        });
    });
});
